import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ErrorMessage } from '../components/ErrorMessage';
import { PageLoader } from '../components/Loader';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { fmtDateTime } from './format';

// SyncFailures: fehlgeschlagene oder widersprüchliche Outlook-Synchronisationen (Verwaltung und Posteingang).
export function SyncFailures() {
  const { project } = useProject();
  const papi = useProjectApi();
  const queryClient = useQueryClient();
  const sync = useQuery({ queryKey: projectKeys.sync(project.id), queryFn: ({ signal }) => papi.calendarSync(undefined, signal) });
  const retry = useMutation({
    mutationFn: (id: string) => papi.retryCalendarSync(id),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: projectKeys.sync(project.id) }),
  });
  return (
    <section className="card" aria-labelledby="sync-title">
      <h2 id="sync-title">Outlook-Synchronisation</h2>
      {sync.isPending ? (
        <PageLoader />
      ) : sync.isError ? (
        <ErrorMessage error={sync.error} />
      ) : sync.data.items.length === 0 ? (
        <p className="muted">Keine Fehler oder Konflikte.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Termin</th>
              <th>Mitarbeiter</th>
              <th>Status</th>
              <th>Fehler</th>
              <th aria-label="Aktion" />
            </tr>
          </thead>
          <tbody>
            {sync.data.items.map((s) => (
              <tr key={s.id}>
                <td>
                  {s.title} <span className="muted">· {fmtDateTime(s.start_at)}</span>
                </td>
                <td>{s.user_name}</td>
                <td>
                  <span className={s.status === 'CONFLICT' ? 'badge badge-warn' : 'badge badge-error'}>{s.status === 'CONFLICT' ? 'Konflikt' : 'Fehlgeschlagen'}</span>
                </td>
                <td>{s.last_error ?? '–'}</td>
                <td>
                  <button type="button" className="btn btn-small" disabled={retry.isPending} onClick={() => retry.mutate(s.id)}>
                    {s.status === 'CONFLICT' ? 'Maklerpass übernehmen' : 'Erneut versuchen'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
